import { QueryClientProvider } from "@tanstack/react-query"
import { Provider as ReduxProvider } from "react-redux"
import { PersistGate } from "redux-persist/integration/react"
import { getQueryClient } from "@/lib/http/client"
import { store, persistor } from "@/lib/store"
import { ThemeProvider } from "@/components/theme-provider"

interface ProviderProps {
  children: React.ReactNode
}

export default function Provider({ children }: ProviderProps) {
  const queryClient = getQueryClient()

  return (
    <ThemeProvider attribute="class" defaultTheme="light" enableSystem disableTransitionOnChange>
      <ReduxProvider store={store}>
        <PersistGate loading={null} persistor={persistor}>
          <QueryClientProvider client={queryClient}>{children}</QueryClientProvider>
        </PersistGate>
      </ReduxProvider>
    </ThemeProvider>
  )
}
